var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AF6A34",
    d: "M5.268 16.557v1.725c0 .15.171.232.287.14l10.063-7.859a.712.712 0 0 0 0-1.123L5.555 1.581a.178.178 0 0 0-.287.14v1.726c0 .11.05.214.136.281l8.035 6.273-8.035 6.274a.36.36 0 0 0-.136.282"
  })));
};
export default SvgArrow;